import React, { useRef} from "react";
import { useCursor } from "../cursor/useCursor";
import MagneticRoundButton from "../buttons/MagneticRoundButton";
import { useScroll, useTransform, motion } from "framer-motion";
import {CURSORS} from "../cursor/cursors";
import LiveClock from "../animations/LiveClock";
import hero from "../../../assets/images/hero_img.webp"
import mac from "../../../assets/images/mac_round_b.png"
import ter from "../../../assets/images/terminal_round_b.png"

export default function HeroContainer({ homeRef }) {
  const heroref = useRef(null);


  const { cursor } = useCursor();

  const today = new Date();

  const day = today.toLocaleDateString("en-US", {
    weekday: "long",
  });

  const month = today.toLocaleDateString("en-US", {
    month: "long",
  });



  
  

  // ---------------------------------------
  // SCROLL ANIMATION
  // ---------------------------------------

  const { scrollYProgress } = useScroll({
    target: homeRef,
    offset: ["start start", "end start"],
  });

  const scale = useTransform(
    scrollYProgress,
    [0, 1],
    [1, 0.82]
  );

  const rotate = useTransform(
    scrollYProgress,
    [0, 1],
    [0, 5]
  );

  const opacity = useTransform(
    scrollYProgress,
    [0, 1],
    [1, 0.01]
  );


  return (
    <motion.section
    {...cursor(CURSORS.hero)}
      ref={heroref}
      
      style={{
        scale,
        opacity,
        rotate,
      }}
      className="
        sticky top-0
        flex h-screen
        items-center justify-center
        bg-white

        p-3
        sm:p-4
        md:p-6
        lg:p-8
      "
    >
      <div
        className="
          relative
          h-full w-full
          overflow-hidden
          bg-[#f1f1f1]

          rounded-[65px]
          sm:rounded-[55px]
          md:rounded-[75px]
          lg:rounded-[110px]
          xl:rounded-[135px]
        "
      >

        {/* =====================================
            TOP INFORMATION
        ===================================== */}

        <div
          className="
            absolute
            left-5 right-5 top-6
            px-2
            flex
            items-center
            justify-between

            font-pixeloperator
            text-[13px]
            font-medium
            tracking-wide

            sm:left-8 sm:right-8
            sm:top-8
            sm:text-[15px]

            md:left-10 md:right-10
            md:top-10
            md:text-[17px]

            lg:left-14 lg:right-14
            lg:top-12
            lg:text-[18px]
          "
        >
          <p>{day}</p>

          <LiveClock/>

          <p>{month}</p>
        </div>


        {/* =====================================
            NAME
        ===================================== */}

        <div
          className="absolute left-6 top-[26%] z-10 sm:left-8 sm:top-[38%] md:left-10 md:top-[40%] lg:left-16 lg:top-1/2 lg:-translate-y-1/2"
        >
          <h1
          {...cursor({...CURSORS.hero,size:50})}
            className="font-dotgothic text-[75px] leading-none sm:text-[70px] md:text-[90px] lg:text-[110px] xl:text-[125px]"
          >
            Badusha.
          </h1>

          <div
            className="
              mt-2
              flex
              items-center
              gap-2

              font-thesignature
              text-[28px]

              sm:mt-3
              sm:gap-3
              sm:text-[28px]

              md:text-[34px]

              lg:gap-5
              lg:text-[40px]
            "
          >
            <p>
              Developer
            </p>

            <p
              className="
                text-[25px]
                text-green-600

                sm:text-[26px]

                md:text-[30px]

                lg:text-[34px]
              "
            >
              /
            </p>

            <p>
              Designer
            </p>
          </div>
        </div>


        {/* =====================================
            HERO IMAGE
        ===================================== */}

        <img
          src={hero}
          alt=""
          className="
            pointer-events-none
            absolute
            bottom-0
            left-1/2
            z-[1]
            h-[55%]
            -translate-x-1/2
            object-contain
            select-none
            sm:h-[53%]
            md:h-[60%]
            lg:h-[70%]
            xl:h-[78%]
          "
        />


        {/* =====================================
            MAGNETIC BUTTON — DESKTOP ONLY
        ===================================== */}

        <div
          className="
            absolute
            bottom-3
            right-0
            hidden
            w-[260px]

            lg:block
            xl:w-[300px]
          "
        >
          <MagneticRoundButton
            text="mac os view - mac os view - mac os view - "
            src={mac}
            radius={55}
            size={220}
            to="/mac-os"
          />
        </div>


        {/* =====================================
            SECOND MAGNETIC BUTTON — DESKTOP ONLY
        ===================================== */}

        <div
          className="
            absolute
            bottom-1/4
            right-0
            hidden
            w-[320px]

            lg:block
            xl:w-[400px]
          "
        >
          <MagneticRoundButton
            text="terminal view - terminal view - terminal view -"
            src={ter}
            radius={60}
            size={220}
            to="/terminal"
          />
        </div>

      </div>
    </motion.section>
  );
}